"use client"

import { useState, useEffect } from "react"

export function useHeaderWidth() {
  const [headerWidth, setHeaderWidth] = useState<number | null>(null)

  useEffect(() => {
    // Function to measure the header width
    const measureHeaderWidth = () => {
      const headerElement = document.querySelector('[data-header-container="true"]')
      if (headerElement) {
        // Get the computed style to check if there's a max-width constraint
        const computedStyle = window.getComputedStyle(headerElement)
        const maxWidth = computedStyle.maxWidth

        // Get the actual width from getBoundingClientRect
        const rect = headerElement.getBoundingClientRect()
        const actualWidth = rect.width

        // Use the appropriate width based on device
        if (window.innerWidth < 768) {
          // md breakpoint
          setHeaderWidth(actualWidth)
        } else {
          // On desktop, respect the max-width if it's not 'none'
          const parsedMaxWidth = maxWidth !== "none" ? Number.parseInt(maxWidth) : null
          setHeaderWidth(parsedMaxWidth || actualWidth)
        }
      }
    }

    // Initial measurement with a small delay to ensure DOM is ready
    const initialMeasurementTimeout = setTimeout(measureHeaderWidth, 100)
    // And also measure after content has likely loaded
    const secondMeasurementTimeout = setTimeout(measureHeaderWidth, 500)

    // Re-measure on resize and orientation change
    window.addEventListener("resize", measureHeaderWidth)
    window.addEventListener("orientationchange", measureHeaderWidth)

    // Custom event for when the header might change size
    window.addEventListener("headerSizeChange", measureHeaderWidth)

    return () => {
      clearTimeout(initialMeasurementTimeout)
      clearTimeout(secondMeasurementTimeout)
      window.removeEventListener("resize", measureHeaderWidth)
      window.removeEventListener("orientationchange", measureHeaderWidth)
      window.removeEventListener("headerSizeChange", measureHeaderWidth)
    }
  }, [])

  return headerWidth
}
